var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getHeaders } from "../utils/apiUtils";
import { API_PATHS, legalDepositsPublishersId, legalDepositsPublishersIdLocalContacts, legalDepositsPublishersIdPrefixHistory, legalDepositsPublishersIdReminderSettings, legalDepositsPublishersLookup, legalDepositsPublishersCheckDuplicity, } from "../types/apiPaths";
export var fetchReminderSettings = function (kyInstance, publisherId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.get(legalDepositsPublishersIdReminderSettings(publisherId), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
            case 2:
                error_1 = _a.sent();
                console.error("Error fetching reminder settings:", error_1);
                throw error_1;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var patchReminderSettings = function (kyInstance, publisherId, data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.patch(legalDepositsPublishersIdReminderSettings(publisherId), { json: data, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
            case 2:
                error_2 = _a.sent();
                console.error("Error patching reminder settings:", error_2);
                throw error_2;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var fetchPublishers = function (kyInstance_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([kyInstance_1], args_1, true), void 0, function (kyInstance, params) {
        var search, owner, regionId, publisherPrefix, sortBy, sortDir, offset, limit, searchParams_1, response, error_3;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    search = params.search, owner = params.owner, regionId = params.regionId, publisherPrefix = params.publisherPrefix, sortBy = params.sortBy, sortDir = params.sortDir, offset = params.offset, limit = params.limit;
                    searchParams_1 = new URLSearchParams();
                    if (search)
                        searchParams_1.append("search", search);
                    if (owner)
                        owner.forEach(function (o) { return searchParams_1.append("owner", o); });
                    if (regionId)
                        searchParams_1.append("regionId", regionId);
                    if (publisherPrefix)
                        searchParams_1.append("publisherPrefix", publisherPrefix);
                    if (sortBy)
                        searchParams_1.append("sortBy", sortBy);
                    if (sortDir)
                        searchParams_1.append("sortDir", sortDir);
                    if (params.exactCount)
                        searchParams_1.append("exactCount", "true");
                    if (params.countOnly)
                        searchParams_1.append("countOnly", "true");
                    if (offset !== undefined)
                        searchParams_1.append("offset", offset.toString());
                    if (limit !== undefined)
                        searchParams_1.append("limit", limit.toString());
                    return [4 /*yield*/, kyInstance.get(API_PATHS.LEGAL_DEPOSITS_PUBLISHERS, {
                            searchParams: searchParams_1,
                            headers: getHeaders(),
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Fetch error: ".concat(response.statusText));
                    }
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    error_3 = _a.sent();
                    console.error("Error fetching publishers:", error_3);
                    throw error_3;
                case 4: return [2 /*return*/];
            }
        });
    });
};
export var fetchPublishersByTitleContext = function (kyInstance, context, search) { return __awaiter(void 0, void 0, void 0, function () {
    var searchParams, response, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                searchParams = new URLSearchParams();
                searchParams.append("context", context);
                if (search)
                    searchParams.append("search", search);
                return [4 /*yield*/, kyInstance.get("".concat(API_PATHS.LEGAL_DEPOSITS_PUBLISHERS, "/by-title-context"), { searchParams: searchParams, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Fetch error: ".concat(response.statusText));
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_4 = _a.sent();
                console.error("Error fetching publishers by context:", error_4);
                throw error_4;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchPublisherById = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get(legalDepositsPublishersId(id), {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_5 = _a.sent();
                console.error("Error fetching publisher by ID:", error_5);
                throw error_5;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var createPublisher = function (kyInstance, payload) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_PUBLISHERS, {
                        json: payload,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Create error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_6 = _a.sent();
                console.error("Error creating publisher:", error_6);
                throw error_6;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var updatePublisher = function (kyInstance, id, payload) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.put(legalDepositsPublishersId(id), {
                        json: payload,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Update error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_7 = _a.sent();
                console.error("Error updating publisher:", error_7);
                throw error_7;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var updatePublisherContacts = function (kyInstance, id, payload) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.put(legalDepositsPublishersIdLocalContacts(id), {
                        json: payload,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Update error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_8 = _a.sent();
                console.error("Error updating publisher:", error_8);
                throw error_8;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var lookupPublisherByCompanyNumber = function (kyInstance, companyNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get(legalDepositsPublishersLookup(companyNumber), {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, (_a.sent())];
            case 3:
                error_9 = _a.sent();
                console.error("Error lookup publisher:", error_9);
                throw error_9;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var checkDuplicateCompanyNumber = function (kyInstance, companyNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get(legalDepositsPublishersCheckDuplicity(companyNumber), {
                        headers: __assign(__assign({}, getHeaders()), { Pragma: "no-cache", Expires: "0" }),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Check Duplicity error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_10 = _a.sent();
                console.error("Error check duplicity:", error_10);
                throw error_10;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchPublisherPrefixHistory = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get(legalDepositsPublishersIdPrefixHistory(id), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch prefix history error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_11 = _a.sent();
                console.error("Error fetching publisher prefix history:", error_11);
                throw error_11;
            case 4: return [2 /*return*/];
        }
    });
}); };
